export default __webpack_public_path__ + "static/media/Banner concurso de bandas_Mesa.739614ae.png";